import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=3640bb4c&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=ts&"
export * from "./Notification.vue?vue&type=script&lang=ts&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=3640bb4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640bb4c",
  null
  
)

export default component.exports